import { render, staticRenderFns } from "./goback.vue?vue&type=template&id=38ffe6a1"
import script from "./goback.vue?vue&type=script&lang=js"
export * from "./goback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports